import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";

const CtaFinal = () => {
  const { t } = useLang();
  return (
    <section
      data-testid="cta-final-section"
      className="relative bg-[#002B6B] text-white py-28 md:py-40 overflow-hidden grain-overlay"
    >
      <div
        className="absolute inset-0 pointer-events-none opacity-40"
        style={{ background: "radial-gradient(900px 500px at 20% 50%, rgba(111,45,189,0.6), transparent 60%)" }}
      />
      <div className="relative max-w-[1480px] mx-auto px-6 md:px-12 text-center">
        <motion.h2
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9 }}
          className="font-display text-4xl md:text-6xl lg:text-7xl uppercase leading-[1.02] tracking-tight max-w-5xl mx-auto"
        >
          {t.cta.title}
        </motion.h2>
        <motion.p
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.15 }}
          className="mt-8 text-base md:text-xl text-white/75 font-editorial font-light max-w-3xl mx-auto leading-relaxed"
        >
          {t.cta.lead}
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="mt-12"
        >
          <a
            href="#contact"
            data-testid="cta-final-button"
            className="group inline-flex items-center gap-3 bg-white text-[#002B6B] px-10 py-5 text-[12px] tracking-[0.22em] uppercase font-bold hover:bg-[#B89DDE] hover:text-white transition-colors"
          >
            {t.cta.button}
            <span className="inline-block transition-transform group-hover:translate-x-1">→</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default CtaFinal;
